window.penSearchData = {
"AG-171": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-172": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-173": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-174": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-175": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-176": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-177": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-178": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-179": [
{
"name": "Advanced Gray",
"handle": "lg720-advanced-gray",
"url": "/products/lg720-advanced-gray"
}
],
"AG-245": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-246": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-247": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-248": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-249": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-250": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-253": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-254": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"AG-256": [
{
"name": "Cocoa Brown Series",
"handle": "lg720-cocoa-brown-series",
"url": "/products/lg720-cocoa-brown-series"
}
],
"BG-02": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-03": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-101": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-102": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-104": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-111": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-112": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-113": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-114": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-116": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-117": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "12 - Sketch",
"handle": "lg-1-plus12-sketch",
"url": "/products/lg-1-plus12-sketch"
},
{
"name": "12 - Sketch",
"handle": "lg-07-click12-sketch",
"url": "/products/lg-07-click12-sketch"
}
],
"BG-121": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-122": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-124": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-125": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-126": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-128": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "35 - Sweet Pink",
"handle": "lg-3d-35-sweet-pink",
"url": "/products/lg-3d-35-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-07-click9-sweet-pink",
"url": "/products/lg-07-click9-sweet-pink"
},
{
"name": "9 - Sweet Pink",
"handle": "lg-1-plus9-sweet-pink",
"url": "/products/lg-1-plus9-sweet-pink"
}
],
"BG-131": [
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
}
],
"BG-132": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-133": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-135": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-136": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-137": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-138": [
{
"name": "37 - Milk & Coffee",
"handle": "lg-3d-37-milk-coffee",
"url": "/products/lg-3d-37-milk-coffee"
}
],
"BG-139": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "13 - Maillard",
"handle": "lg-1-plus13-maillard",
"url": "/products/lg-1-plus13-maillard"
},
{
"name": "13 - Maillard",
"handle": "lg-07-click13-maillard",
"url": "/products/lg-07-click13-maillard"
}
],
"BG-151": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-152": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-154": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-155": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-157": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-158": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
},
{
"name": "14 - Colourful Black",
"handle": "lg-07-click14-colourful-black",
"url": "/products/lg-07-click14-colourful-black"
},
{
"name": "14 - Colourful Black",
"handle": "lg-1-plus14-colourful-black",
"url": "/products/lg-1-plus14-colourful-black"
}
],
"BG-161": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-162": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-163": [
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
}
],
"BG-164": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-166": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-167": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-168": [
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
}
],
"BG-169": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "3 - Lipstick red",
"handle": "lg-07-click3-lipstick-red",
"url": "/products/lg-07-click3-lipstick-red"
},
{
"name": "3 - Lipstick Red",
"handle": "lg-1-plus3-lipstick-red",
"url": "/products/lg-1-plus3-lipstick-red"
}
],
"BG-171": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-173": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-175": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-176": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-177": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-178": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-07-click1-warm-yellow",
"url": "/products/lg-07-click1-warm-yellow"
},
{
"name": "1 - Warm Yellow",
"handle": "lg-1-plus1-yellow",
"url": "/products/lg-1-plus1-yellow"
}
],
"BG-181": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-183": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-184": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-185": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-187": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-188": [
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
}
],
"BG-189": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "38 - Dopamine",
"handle": "lg-3d-38-dopamine",
"url": "/products/lg-3d-38-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-07-click15-dopamine",
"url": "/products/lg-07-click15-dopamine"
},
{
"name": "15 - Dopamine",
"handle": "lg-1-plus15-dopamine",
"url": "/products/lg-1-plus15-dopamine"
}
],
"BG-191": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-192": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-193": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-196": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-197": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-199": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-07-click11-colour-of-skin-2",
"url": "/products/lg-07-click11-colour-of-skin-2"
},
{
"name": "11 - Colour of Skin 2",
"handle": "lg-1-plus11-colour-of-skin-2",
"url": "/products/lg-1-plus11-colour-of-skin-2"
}
],
"BG-201": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-202": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-203": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-204": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-301": [
{
"name": "7 - Nordic Blue",
"handle": "lg-1-plus7-nordic-blue",
"url": "/products/lg-1-plus7-nordic-blue"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "7 - Nordic Blue",
"handle": "lg-07-click7-nordic-blue",
"url": "/products/lg-07-click7-nordic-blue"
}
],
"BG-303": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-304": [
{
"name": "5 - The Wizard Of Oz",
"handle": "lg-1-plus5-the-wizard-of-oz",
"url": "/products/lg-1-plus5-the-wizard-of-oz"
},
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "5 - The Wizard of Oz",
"handle": "lg-07-click5-the-wizard-of-oz",
"url": "/products/lg-07-click5-the-wizard-of-oz"
}
],
"BG-501": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-502": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-503": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-504": [
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
}
],
"BG-505": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-506": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-508": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-07-click8-monet-purple",
"url": "/products/lg-07-click8-monet-purple"
},
{
"name": "8 - Monet Purple",
"handle": "lg-1-plus8-monet-purple",
"url": "/products/lg-1-plus8-monet-purple"
}
],
"BG-509": [
{
"name": "34 - Monet Purple",
"handle": "lg-3d-34-monet-purple",
"url": "/products/lg-3d-34-monet-purple"
}
],
"BG-601": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-602": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-603": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-604": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-606": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-607": [
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
}
],
"BG-608": [
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
}
],
"BG-609": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "36 - Colour of Skin",
"handle": "lg-3d-36-colour-of-skin",
"url": "/products/lg-3d-36-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-07-click10-colour-of-skin",
"url": "/products/lg-07-click10-colour-of-skin"
},
{
"name": "10 - Colour of Skin",
"handle": "lg-1-plus10-colour-of-skin",
"url": "/products/lg-1-plus10-colour-of-skin"
}
],
"BG-701": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-702": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-703": [
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
}
],
"BG-704": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-705": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-706": [
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
}
],
"BG-707": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-709": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "33 - Sea Salt Blue",
"handle": "lg-3d-33-sea-salt-blue",
"url": "/products/lg-3d-33-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-07-click6-sea-salt-blue",
"url": "/products/lg-07-click6-sea-salt-blue"
},
{
"name": "6 - Sea Salt Blue",
"handle": "lg-1-plus6-sea-salt-blue",
"url": "/products/lg-1-plus6-sea-salt-blue"
}
],
"BG-801": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-802": [
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
}
],
"BG-803": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-804": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-805": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-806": [
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
}
],
"BG-807": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-808": [
{
"name": "32 - Natural Forest",
"handle": "lg-3d-32-natural-forest",
"url": "/products/lg-3d-32-natural-forest"
}
],
"BG-809": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "4 - Natural Forest",
"handle": "lg-07-click4-natural-forest",
"url": "/products/lg-07-click4-natural-forest"
},
{
"name": "4 - Natural Forest",
"handle": "lg-1-plus4-natural-forest",
"url": "/products/lg-1-plus4-natural-forest"
}
],
"BG-901": [
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
}
],
"BG-902": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BG-903": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "31 - Warm Yellow",
"handle": "lg-3d-31-warm-yellow",
"url": "/products/lg-3d-31-warm-yellow"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BG-904": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BG-906": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BG-907": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "30 - Vibrant Red",
"handle": "lg-3d-30-vibrant-red",
"url": "/products/lg-3d-30-vibrant-red"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BG-909": [
{
"name": "90 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-90",
"url": "/products/lg-07-click-set-90"
},
{
"name": "72 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-72",
"url": "/products/lg-07-click-set-72"
},
{
"name": "54 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-54",
"url": "/products/lg-07-click-set-54"
},
{
"name": "36 Colour Retractable Gel Pen Set – 0.7mm",
"handle": "lg-07-click-set-36",
"url": "/products/lg-07-click-set-36"
},
{
"name": "90 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-90",
"url": "/products/lg-1-plus-set-90"
},
{
"name": "72 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-72",
"url": "/products/lg-1-plus-set-72"
},
{
"name": "54 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-54",
"url": "/products/lg-1-plus-set-54"
},
{
"name": "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
"handle": "lg-1-plus-set-36",
"url": "/products/lg-1-plus-set-36"
},
{
"name": "2 - Vitality & Warmth",
"handle": "lg-07-click2-vitality-warmth",
"url": "/products/lg-07-click2-vitality-warmth"
},
{
"name": "2- Warmth & Vitality",
"handle": "lg-1-plus2-warm-yellow",
"url": "/products/lg-1-plus2-warm-yellow"
}
],
"BL-201": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-202": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-203": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-204": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-205": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-206": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-207": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-208": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-209": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Blue Series",
"handle": "lg720-blue-series",
"url": "/products/lg720-blue-series"
}
],
"BL-210": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BL-211": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BL-212": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BL-213": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BL-214": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BL-257": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-259": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-260": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-261": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-264": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-265": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-266": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-267": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BL-268": [
{
"name": "Galaxy Purple",
"handle": "lg720-galaxy-purple",
"url": "/products/lg720-galaxy-purple"
}
],
"BR-701": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-702": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-703": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-704": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-705": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-706": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-707": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-708": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-709": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Maillard",
"handle": "lg720-maillard",
"url": "/products/lg720-maillard"
}
],
"BR-710": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BR-711": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BR-712": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BR-713": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BR-714": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BR-715": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"BS-01": [
{
"name": "20 - Mermaid Dream",
"handle": "lg-1-shinyplus-20-mermaid-dream",
"url": "/products/lg-1-shinyplus-20-mermaid-dream"
}
],
"BS-02": [
{
"name": "20 - Mermaid Dream",
"handle": "lg-1-shinyplus-20-mermaid-dream",
"url": "/products/lg-1-shinyplus-20-mermaid-dream"
}
],
"BS-03": [
{
"name": "20 - Mermaid Dream",
"handle": "lg-1-shinyplus-20-mermaid-dream",
"url": "/products/lg-1-shinyplus-20-mermaid-dream"
}
],
"BS-04": [
{
"name": "20 - Mermaid Dream",
"handle": "lg-1-shinyplus-20-mermaid-dream",
"url": "/products/lg-1-shinyplus-20-mermaid-dream"
}
],
"BS-09": [
{
"name": "22 - Firefly Forest",
"handle": "lg-1-shinyplus-22-firefly-forest",
"url": "/products/lg-1-shinyplus-22-firefly-forest"
}
],
"BS-10": [
{
"name": "22 - Firefly Forest",
"handle": "lg-1-shinyplus-22-firefly-forest",
"url": "/products/lg-1-shinyplus-22-firefly-forest"
}
],
"BS-11": [
{
"name": "22 - Firefly Forest",
"handle": "lg-1-shinyplus-22-firefly-forest",
"url": "/products/lg-1-shinyplus-22-firefly-forest"
}
],
"BS-12": [
{
"name": "22 - Firefly Forest",
"handle": "lg-1-shinyplus-22-firefly-forest",
"url": "/products/lg-1-shinyplus-22-firefly-forest"
}
],
"CB-901": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-902": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-903": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-904": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-905": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-906": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-907": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-908": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-909": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colourful Black",
"handle": "lg720-colourful-black",
"url": "/products/lg720-colourful-black"
}
],
"CB-910": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"CS-141": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-142": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-143": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-144": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-145": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-146": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-147": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-148": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-149": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Colour of Skin 2.0",
"handle": "lg720-colour-of-skin-20",
"url": "/products/lg720-colour-of-skin-20"
}
],
"CS-501": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-502": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-503": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-504": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-505": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-506": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-507": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-508": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-509": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Skin Colours",
"handle": "lgpro-skin",
"url": "/products/lgpro-skin"
},
{
"name": "Colour Of Skin",
"handle": "lg720-colour-of-skin",
"url": "/products/lg720-colour-of-skin"
}
],
"CS-510": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"CS-511": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"DB-161": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-162": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-163": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-164": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-165": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-166": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-167": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-168": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DB-169": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dusty Blue",
"handle": "lg720-dusty-blue",
"url": "/products/lg720-dusty-blue"
}
],
"DS-181": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-182": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-183": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-184": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-185": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-186": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-187": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-188": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"DS-189": [
{
"name": "Dark Skin",
"handle": "lgpro-dark-skin",
"url": "/products/lgpro-dark-skin"
},
{
"name": "Dark Skin",
"handle": "lg720-dark-skin",
"url": "/products/lg720-dark-skin"
}
],
"F01": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
}
],
"F02": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F03": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
}
],
"F04": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F05": [
{
  "name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
}
],
"F06": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
}
],
"F07": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F08": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F09": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F10": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
}
],
"F11": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F12": [
{
"name": "Brown",
"handle": "brown",
"url": "/products/brown"
},
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
}
],
"F13": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F14": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F15": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F16": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F17": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F18": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F19": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F20": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F21": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F22": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F23": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F24": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Light Skin",
"handle": "g-hg-light-skin",
"url": "/products/g-hg-light-skin"
}
],
"F25": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F26": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F27": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F28": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F29": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F30": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F31": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F32": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F33": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F34": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F35": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "72 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set",
"url": "/products/72-colour-high-gloss-pen-set"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F36": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Warm Skin",
"handle": "g-hg-warm-skin",
"url": "/products/g-hg-warm-skin"
}
],
"F37": [
{
"name": "168 Colour High Gloss Pen Set",
"handle": "72-colour-high-gloss-pen-set-copy",
"url": "/products/72-colour-high-gloss-pen-set-copy"
},
{
"name": "Macaron",
"handle": "g-hg-macaron",
"url": "/products/g-hg-macaron"
}
],
"GB-401": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-402": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-403": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-404": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-405": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-406": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-407": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-408": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-409": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Gray Brown",
"handle": "lg720-gray-brown",
"url": "/products/lg720-gray-brown"
}
],
"GB-410": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GB-411": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GB-412": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-101": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-102": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-103": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-104": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-105": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-106": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-107": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-108": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-109": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Green",
"handle": "lg720-green",
"url": "/products/lg720-green"
}
],
"GR-110": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-111": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-112": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-113": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-114": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"GR-115": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"HC-131": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-132": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-133": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-134": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-135": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-136": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-137": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-138": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-139": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine 2.0",
"handle": "lg720-dopamine-20",
"url": "/products/lg720-dopamine-20"
}
],
"HC-601": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-602": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-603": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-604": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-605": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-606": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-607": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-608": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"HC-609": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Dopamine",
"handle": "lg720-dopamine",
"url": "/products/lg720-dopamine"
}
],
"LC-111": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-112": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-113": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-114": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-115": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-116": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-117": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-118": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-119": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Lip Gloss Red",
"handle": "lg720-lip-gloss-red",
"url": "/products/lg720-lip-gloss-red"
}
],
"LC-191": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-192": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-193": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-194": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-195": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-196": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-197": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-198": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"LC-199": [
{
"name": "Light Colours",
"handle": "lgpro-light-colour",
"url": "/products/lgpro-light-colour"
},
{
"name": "Light Colour",
"handle": "lg720-light-colour",
"url": "/products/lg720-light-colour"
}
],
"PC-233": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-235": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-237": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-238": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-239": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-240": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-242": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-243": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-244": [
{
"name": "Candy Pink",
"handle": "lg720-candy-pink",
"url": "/products/lg720-candy-pink"
}
],
"PC-801": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-802": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-803": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-804": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-805": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-806": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-807": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-808": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-809": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Sweet Pink",
"handle": "lg720-sweet-pink",
"url": "/products/lg720-sweet-pink"
}
],
"PC-810": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-811": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-812": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-813": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-814": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-815": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PC-816": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-301": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-302": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-303": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-304": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-305": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-306": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-307": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-308": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-309": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Purple Series",
"handle": "lg720-purple-series",
"url": "/products/lg720-purple-series"
}
],
"PU-310": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-311": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-312": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-313": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-314": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"PU-315": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"RY-01": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-02": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-03": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-04": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-05": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-06": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-07": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-08": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-09": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Red Yellow",
"handle": "lg720-red-yellow",
"url": "/products/lg720-red-yellow"
}
],
"RY-10": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"RY-11": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"RY-12": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"RY-13": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"RY-14": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"SG-01": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-02": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-03": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-04": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-05": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-06": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "25 - Glitter Eyeshadow",
"handle": "lg-1-shinyplus-25-glitter-eyeshadow",
"url": "/products/lg-1-shinyplus-25-glitter-eyeshadow"
}
],
"SG-11": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-12": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-13": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-14": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-15": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-16": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "26 - Colourful contact lenses",
"handle": "lg-1-shinyplus-26-colourful-contacts",
"url": "/products/lg-1-shinyplus-26-colourful-contacts"
}
],
"SG-21": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-22": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-23": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-24": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-25": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-26": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "27 - Lip Gloss",
"handle": "lg-1-shinyplus-27-lip-gloss",
"url": "/products/lg-1-shinyplus-27-lip-gloss"
}
],
"SG-31": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-32": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-33": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-34": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-35": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-36": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "28 - Magical Girl",
"handle": "lg-1-shinyplus-28-magical-girl",
"url": "/products/lg-1-shinyplus-28-magical-girl"
}
],
"SG-41": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-42": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-43": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-44": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-45": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-46": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "45 - Ocean Blue",
"handle": "lg-1-shinyplus-45-ocean-blue",
"url": "/products/lg-1-shinyplus-45-ocean-blue"
}
],
"SG-51": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-52": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-53": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-54": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-55": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-56": [
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
},
{
"name": "46 - Mint Smoothie",
"handle": "lg-1-shinyplus-46-mint-smoothie",
"url": "/products/lg-1-shinyplus-46-mint-smoothie"
}
],
"SG-61": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-62": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-63": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-64": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-65": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-66": [
{
"name": "47 - Misty Forest",
"handle": "lg-1-shinyplus-47-misty-forest",
"url": "/products/lg-1-shinyplus-47-misty-forest"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-71": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-72": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-73": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-74": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-75": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-76": [
{
"name": "48 - Gilded Earth",
"handle": "lg-1-shinyplus-48-gilded-earth",
"url": "/products/lg-1-shinyplus-48-gilded-earth"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-81": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-82": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-83": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-84": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-85": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-86": [
{
"name": "49 - Mermaid Princess",
"handle": "lg-1-shinyplus-49-mermaid-princess",
"url": "/products/lg-1-shinyplus-49-mermaid-princess"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-91": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-92": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-93": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-94": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-95": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-96": [
{
"name": "50 - Morandi Series",
"handle": "lg-1-shinyplus-50-morani-series",
"url": "/products/lg-1-shinyplus-50-morani-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-101": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-102": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-103": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-104": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-105": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-106": [
{
"name": "51 - Galaxy Purple",
"handle": "lg-1-shinyplus-51-galaxy-purple",
"url": "/products/lg-1-shinyplus-51-galaxy-purple"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-111": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-112": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-113": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-114": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-115": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-116": [
{
"name": "52 - Macaron Series",
"handle": "lg-1-shinyplus-52-macaron-series",
"url": "/products/lg-1-shinyplus-52-macaron-series"
},
{
"name": "72 Colour Super Shiny Plus Gel Pen Set",
"handle": "lg-1-shinyplus-set-72",
"url": "/products/lg-1-shinyplus-set-72"
}
],
"SG-151": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-152": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-153": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-154": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-155": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-156": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-157": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-158": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-159": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Sage Green",
"handle": "lg720-sage-green",
"url": "/products/lg720-sage-green"
}
],
"SG-221": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-222": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-224": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-225": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-226": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-228": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-230": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-231": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"SG-232": [
{
"name": "Forest Green",
"handle": "lg720-forest-green",
"url": "/products/lg720-forest-green"
}
],
"YE-121": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-122": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-123": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-124": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-125": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-126": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 48 Colours",
"handle": "lgpro-set-48",
"url": "/products/lgpro-set-48"
},
{
"name": "Languo Acrylic Marker Set – 48 Colours",
"handle": "lg720-set-36",
"url": "/products/lg720-set-36"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Languo Acrylic Marker Set – 36 Colours",
"handle": "lg720-set-48",
"url": "/products/lg720-set-48"
},
{
"name": "Languo Acrylic Marker Set – 24 Colours",
"handle": "lg720-set-24",
"url": "/products/lg720-set-24"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-127": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-128": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-129": [
{
"name": "Languo Acrylic Marker Set – 60 Colours",
"handle": "languo-acrylic-marker-set-36-colours-copy",
"url": "/products/languo-acrylic-marker-set-36-colours-copy"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 96 Colours",
"handle": "lgpro-set-96",
"url": "/products/lgpro-set-96"
},
{
"name": "Languo Pro Acrylic Brush Marker Set – 72 Colours",
"handle": "lgpro-set-72",
"url": "/products/lgpro-set-72"
},
{
"name": "Languo Acrylic Marker Set – 96 Colours",
"handle": "lg720-set-96",
"url": "/products/lg720-set-96"
},
{
"name": "Warm Yellow",
"handle": "lg720-warm-yellow",
"url": "/products/lg720-warm-yellow"
}
],
"YE-130": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-131": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-132": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-133": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-134": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-135": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
],
"YE-136": [
{
"name": "Languo Pro Acrylic Brush Marker Set – 192 Colours",
"handle": "lgpro-set-192",
"url": "/products/lgpro-set-192"
}
]
};

// Compatibility alias for the new hidden Find My Pen test page
window.FLC_PEN_FINDER_DATA_V2 = window.penSearchData;
